export default __webpack_public_path__ + "static/media/mentor.4b5c43f4.jpeg";